// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.member-modal {
  background: white;
  padding: 10px;
  width: 300px;
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 8px;
  text-align: center;
}

.member-modal h4 {
  margin: 0.5%;
}

.member-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 150px;
  overflow-y: auto;
}
.member-item {
  display: flex;
  align-items: center;
  margin: 8px 0;
}
.member-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 8px;
}
.member-name {
  font-size: 14px;
}
.member-close-btn {
  margin-top: 12px;
  padding: 6px 12px;
  background: #0078d4;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.members-btn {
  margin-left: auto;
  background: none;
  border: none;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}

.member-search {
  width: 94%;
  padding: 6px 8px;
  margin: 12px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.suggestions-list {
  list-style: none;
  padding: 0;
  margin: 0 0 12px;
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.suggestion-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
}
.suggestion-item + .suggestion-item {
  border-top: 1px solid #eee;
}

.suggest-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  margin-right: 8px;
}

.suggestion-item button {
  padding: 4px 8px;
  background: #0078d4;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.no-suggest {
  padding: 6px 8px;
  color: #888;
}

.member-item {
  display: flex;
  align-items: center;
  padding: 6px 0;
}

.member-name {
  flex: 1 1;
  margin-left: 8px;
  text-align: left;
}

.remove-btn {
  background: transparent;
  border: none;
  color: #e00;
  font-size: 18px;
  cursor: pointer;
  margin-left: 12px;
}

.remove-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.creator-badge {
  font-size: 0.8rem;
  color: #888;
  margin-left: 5px;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat/MemberListModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n.member-modal {\n  background: white;\n  padding: 10px;\n  width: 300px;\n  max-height: 80vh;\n  overflow-y: auto;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.member-modal h4 {\n  margin: 0.5%;\n}\n\n.member-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: 150px;\n  overflow-y: auto;\n}\n.member-item {\n  display: flex;\n  align-items: center;\n  margin: 8px 0;\n}\n.member-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  margin-right: 8px;\n}\n.member-name {\n  font-size: 14px;\n}\n.member-close-btn {\n  margin-top: 12px;\n  padding: 6px 12px;\n  background: #0078d4;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.members-btn {\n  margin-left: auto;\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.member-search {\n  width: 94%;\n  padding: 6px 8px;\n  margin: 12px 0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.suggestions-list {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 12px;\n  max-height: 150px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.suggestion-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 8px;\n}\n.suggestion-item + .suggestion-item {\n  border-top: 1px solid #eee;\n}\n\n.suggest-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  margin-right: 8px;\n}\n\n.suggestion-item button {\n  padding: 4px 8px;\n  background: #0078d4;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.no-suggest {\n  padding: 6px 8px;\n  color: #888;\n}\n\n.member-item {\n  display: flex;\n  align-items: center;\n  padding: 6px 0;\n}\n\n.member-name {\n  flex: 1;\n  margin-left: 8px;\n  text-align: left;\n}\n\n.remove-btn {\n  background: transparent;\n  border: none;\n  color: #e00;\n  font-size: 18px;\n  cursor: pointer;\n  margin-left: 12px;\n}\n\n.remove-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.creator-badge {\n  font-size: 0.8rem;\n  color: #888;\n  margin-left: 5px;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
